import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'custom-notifications',
    components: {

    },
})

export default class CustomNotifications extends Vue {

    // ------------------------------------------------------------------
    // Properties
    @Prop()
    private selectedConfig: any;

    private defaultText: any = '';

    private customNotification: any = {};

    private notificationsJSONObj: any = [
        {
            keyProp: 'pending.grading.items',
            keyName: 'pendingGradingItems',
            keyValue: true,
            displayName: 'Pending grading items',
            inputType: 'checkbox',
        },
        {
            keyProp: 'pending.grading.items.interval.day',
            keyName: 'pendingGradingIntervalDay',
            keyValue: '',
            displayName: 'Pending grading items interval day',
            inputType: 'textbox',
            placeholder: 'Enter number of days',
        },
        {
            keyProp: 'wpm.thresholds.exceeds',
            keyName: 'wpmThresholdsEexceeds',
            keyValue: true,
            displayName: 'Words per min thresholds exceeds',
            inputType: 'checkbox',
        },
        {
            keyProp: 'min.perf.on.competency',
            keyName: 'minPerfCompetency',
            keyValue: true,
            displayName: 'Min perf on competency',
            inputType: 'checkbox',
        },
    ];

    // -------------------------------------------------------------------
    // Hooks
    private created() {
        const tenantSettings = this.selectedConfig.tenantConfig;
        if (tenantSettings && tenantSettings.value) {
            this.defaultText = tenantSettings.value;
            this.fillInputBoxs(this.defaultText);
        }
    }

    // ------------------------------------------------------------------
    // Actions

    private onChangeConfig() {
        this.sendInputFields();
        this.$emit('onChangeConfig', this.defaultText);
    }

    private fillInputBoxs(defaultText: any) {
        this.notificationsJSONObj.forEach((element: any) => {
            element.keyValue =  defaultText[element.keyProp];
        });
    }

    private sendInputFields() {
        this.notificationsJSONObj.forEach((element: any) => {
            this.defaultText[element.keyProp] = element.keyValue;
        });
    }
}
